export default __webpack_public_path__ + "static/media/fig-15-surge-tank.97b7cc58.png";